import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import isoSocLogo from '../assets/iso-soc-logo-1.webp';
import bgDesktop from '../assets/fgc-tms-saas-financial-software-hero-banner.webp';
import bgMobile from '../assets/fgc-tms-saas-financial-software-hero-banner-mobile.webp';
import heroScissors from '../assets/Hero-scissors.webp';
import bgAwards from '../assets/bg.jpg';

const SeparatorLine = () => (
    <svg width="927" height="18" viewBox="0 0 927 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[700px] md:max-w-[927px]">
        <path d="M0 9.09961C15.45 9.16628 30.9 9.22961 46.35 9.28961C185.4 9.82961 324.45 10.0996 463.5 10.0996C602.55 10.0996 741.6 9.82961 880.65 9.28961C896.1 9.22961 911.55 9.16628 927 9.09961C911.55 9.03294 896.1 8.96961 880.65 8.90961C741.6 8.36961 602.55 8.09961 463.5 8.09961C324.45 8.09961 185.4 8.36961 46.35 8.90961C30.9 8.96961 15.45 9.03294 0 9.09961Z" fill="url(#paint0_linear_598_286)"/>
        <g opacity="0.89" filter="url(#filter0_f_598_286)">
            <ellipse cx="480.175" cy="9.59961" rx="233.417" ry="4.5" fill="url(#paint1_radial_598_286)"/>
        </g>
        <g opacity="0.89" filter="url(#filter1_f_598_286)">
            <ellipse cx="480.175" cy="8.59961" rx="233.417" ry="5.5" fill="url(#paint2_radial_598_286)"/>
        </g>
        <defs>
            <filter id="filter0_f_598_286" x="243.658" y="1.99961" width="473.035" height="15.2" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.55" result="effect1_foregroundBlur_598_286"/>
            </filter>
            <filter id="filter1_f_598_286" x="243.658" y="-0.00039053" width="473.035" height="17.2" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.55" result="effect1_foregroundBlur_598_286"/>
            </filter>
            <linearGradient id="paint0_linear_598_286" x1="0" y1="10.5996" x2="927" y2="10.5996" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F8C32C"/>
                <stop offset="1" stopColor="#FBDF48"/>
            </linearGradient>
            <radialGradient id="paint1_radial_598_286" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(480.175 9.59961) rotate(90) scale(4.5 233.417)">
                <stop stopColor="#F8C129"/>
                <stop offset="1" stopColor="#FAD43C" stopOpacity="0"/>
            </radialGradient>
            <radialGradient id="paint2_radial_598_286" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(480.175 8.59961) rotate(90) scale(5.5 233.417)">
                <stop stopColor="#F8C129"/>
                <stop offset="1" stopColor="#FEFA34" stopOpacity="0"/>
            </radialGradient>
        </defs>
    </svg>
);

const LaurelLeaf = ({ mirrored = false }) => (
    <svg
        width="70" height="131" viewBox="0 0 70 131" fill="none" xmlns="http://www.w3.org/2000/svg"
        className="w-[52px] h-[98px] sm:w-[60px] sm:h-[112px] md:w-[55px] md:h-[105px] lg:w-[70px] lg:h-[131px] flex-shrink-0"
        style={{ transform: mirrored ? 'scaleX(-1)' : 'none' }}
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M62.2214 113.714C64.8631 98.4284 56.6268 97.2215 56.9633 88.4942C53.9935 90.8236 53.3287 96.2338 53.8087 100.902C54.5406 106.895 56.7869 110.507 59.5882 113.359C55.0536 112.642 50.8893 111.519 47.0951 110.025C52.5968 96.985 45.4547 93.7184 47.6338 85.886C44.4114 87.2367 42.6283 92.0221 42.0559 96.4108C41.45 101.838 42.5857 105.636 44.3862 108.877C40.6256 107.155 37.2604 105.062 34.257 102.657C42.0638 92.5205 36.4528 87.5744 40.247 81.1259C37.0084 81.4468 34.2654 85.2786 32.7174 89.1021C30.9926 93.6094 31.0267 97.23 31.7833 100.53C30.9422 99.7538 30.1346 98.9521 29.3522 98.125C27.6111 96.2681 26.0374 94.2847 24.6245 92.2002C33.6432 86.2242 30.4796 80.0629 35.6117 75.8596C32.667 74.982 29.1086 77.3705 26.6103 80.1724C24.0611 83.1351 22.9505 85.9793 22.5048 88.7987C20.898 85.9799 19.5517 83.0087 18.4496 79.928C27.6363 76.6361 26.0464 70.3399 31.5145 67.7654C29.0157 66.263 25.306 67.58 22.4706 69.5297C19.7365 71.4962 18.1718 73.674 17.1873 75.9697C16.3713 73.0745 15.757 70.0955 15.3364 67.0738C24.3635 65.4028 23.6147 59.3089 28.9905 57.7138C26.8702 55.9664 23.295 56.6502 20.4427 58.043C17.7507 59.4274 16.0678 61.1658 14.89 63.0902C14.6627 60.3809 14.5871 57.6379 14.6543 54.9033C14.6627 54.7685 14.6627 54.6246 14.6711 54.4898C22.941 54.6331 23.2776 49.0544 28.3839 48.6493C26.7352 46.6575 23.3784 46.5816 20.5687 47.2822C18.0111 47.9913 16.2364 49.1561 14.8816 50.5911C15.0922 47.8986 15.445 45.2146 15.925 42.5559C23.1936 44.0751 24.3797 39.1881 29.0067 39.7539C27.829 37.652 24.8087 36.9603 22.1587 37.0867C19.82 37.2468 18.0783 37.9391 16.6653 38.9268C17.2371 36.3945 17.9355 33.9049 18.743 31.4822C25.2629 33.8285 26.8276 29.4904 30.9836 30.5793C30.134 28.52 27.4672 27.5323 25.0523 27.321C22.9069 27.1777 21.2581 27.5997 19.8698 28.334C20.7614 25.9793 21.7711 23.692 22.8817 21.4889C28.1902 24.696 30.2679 21.2187 33.7513 22.9661C33.3223 20.9827 31.1096 19.5983 29.0067 18.9398C27.1558 18.4082 25.6331 18.4588 24.2957 18.8218C25.4987 16.6861 26.803 14.6353 28.2075 12.7025C32.6245 16.4501 34.8786 13.5886 37.7812 15.6484C37.6384 13.8335 35.8463 12.2974 34.0626 11.4198C32.4139 10.6602 31.0172 10.5085 29.7471 10.6855C30.8408 9.31003 31.9849 8.00144 33.1795 6.76085C39.4893 6.22933 39.2283 2.04292 42.9301 1.27485C41.5922 -0.0078762 39.1779 0.244959 37.2094 1.01302C34.7022 2.05134 33.39 3.61275 32.4733 5.37643C30.9674 6.8957 29.537 8.52453 28.1913 10.2635C28.6707 8.93862 28.8981 7.39407 28.6875 5.44385C28.4097 3.17337 27.5013 0.709068 25.8442 0C26.9715 4.13586 23.0933 5.77312 26.2564 12.9054C24.8933 14.8719 23.6315 16.9395 22.4622 19.1005C22.8576 17.48 22.9248 15.6484 22.3782 13.3863C21.7386 10.9298 20.3677 8.34756 18.4328 7.85761C20.3005 12.2722 16.1613 14.7702 20.8723 22.2401C19.8709 24.333 18.9626 26.494 18.1466 28.7139C18.2054 26.9665 17.8856 25.0843 16.9185 22.9155C15.7323 20.4 13.747 17.9188 11.5512 17.843C14.4112 22.1474 10.5246 25.8023 16.8177 32.6643C16.0857 35.0275 15.4546 37.4497 14.9416 39.9061C14.8156 37.9228 14.2516 35.8293 12.8723 33.5082C11.2739 30.9422 8.81709 28.5369 6.41121 28.7734C10.0794 33.0779 6.2096 37.6609 14.134 44.287C13.7638 46.6923 13.4945 49.1229 13.3348 51.5541C12.8219 49.5623 11.8373 47.5447 10.0368 45.477C7.87457 43.0801 4.80393 41.0456 2.27203 41.8137C6.9494 45.595 3.71075 51.2923 13.1579 56.6266C13.1495 59.1083 13.2587 61.581 13.4861 64.0285C12.5693 62.1041 11.1642 60.2556 8.9347 58.5257C6.17544 56.4749 2.54085 55.0146 0 56.4153C5.65349 59.3443 3.34001 66.0877 14.2343 69.5994C14.6884 72.2665 15.3028 74.8831 16.0767 77.4491C14.815 75.4068 13.0145 73.5414 10.23 71.9631C7.0166 70.241 2.94463 69.2959 0.437382 71.195C6.96564 73.4234 5.26651 81.1967 18.0284 82.9694C19.0382 85.4343 20.2075 87.8143 21.5449 90.1017C19.778 88.3711 17.5149 86.9704 14.3351 86.118C10.5997 85.2067 6.14128 85.3331 3.9706 88.0003C11.298 88.5234 11.2812 97.1496 25.1123 95.4107C26.0968 96.7018 27.1564 97.943 28.2753 99.1414C28.8219 99.7235 29.3774 100.289 29.9492 100.838C27.8206 100.103 25.3727 99.7994 22.3776 100.179C18.3393 100.796 13.9397 102.737 12.6779 106.282C20.0222 103.868 22.9584 112.097 35.5187 105.48C37.6138 106.965 39.8595 108.315 42.2743 109.523C39.9021 109.43 37.3024 109.894 34.3326 111.245C30.3698 113.153 26.3908 116.529 26.0374 120.546C32.9191 115.743 38.1016 123.272 49.24 112.393C51.848 113.262 54.5989 113.971 57.5183 114.512C54.9607 115.086 52.3022 116.327 49.459 118.681C45.8669 121.779 42.6193 126.404 43.2337 130.616C49.1056 123.695 56.2398 129.89 65.0059 115.482C66.3942 115.592 67.8072 115.659 69.2459 115.702C69.6581 115.71 69.9947 115.381 70.0031 114.976C70.0115 114.562 69.6917 114.225 69.2879 114.216C66.84 114.153 64.4845 113.984 62.2214 113.714Z" fill="url(#paint0_radial_598_273)"/>
        <defs>
            <radialGradient id="paint0_radial_598_273" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(15.8838 34.604) rotate(66.5713) scale(92.7375 49.7025)">
                <stop stopColor="#FBE34C"/>
                <stop offset="0.00480769" stopColor="#FBE34C"/>
                <stop offset="0.399038" stopColor="#F8C32B"/>
                <stop offset="0.769231" stopColor="#C58712"/>
                <stop offset="1" stopColor="#FBE34C"/>
            </radialGradient>
        </defs>
    </svg>
);

const BannerBackground = ({ desktop = true }) => desktop ? (
    <>
        <div className="absolute inset-0 hidden md:block z-0">
            <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, #0B1221 0%, #1a2542 100%)', zIndex: -2 }} />
            <div className="absolute inset-0" style={{
                backgroundImage: `linear-gradient(to right, #0B1221 0%, #0B1221 40%, transparent 100%), url(${bgDesktop})`,
                backgroundPosition: 'right center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                zIndex: -1
            }} />
        </div>
        <div className="absolute inset-0 md:hidden z-0" style={{
            backgroundImage: `linear-gradient(to right, #080D1A 0%, #080D1A 40%, transparent 100%), url(${bgMobile})`,
            backgroundPosition: 'center, center bottom',
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundSize: 'cover, cover',
            backgroundColor: '#080D1A'
        }} />
    </>
) : null;

const Hero = () => {
    const [current, setCurrent] = useState(0);
    const timerRef = useRef(null);
    const SLIDE_COUNT = 2;

    const startTimer = () => {
        timerRef.current = setInterval(() => {
            setCurrent(prev => (prev + 1) % SLIDE_COUNT);
        }, 5000);
    };

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToSlide = (index) => {
        setCurrent(index);
        clearInterval(timerRef.current);
        startTimer();
    };

    return (
        <section className="relative w-full min-h-[70vh] md:min-h-screen bg-[#080D1A] overflow-hidden">
            {/* Slides track */}
            <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${current * 100}%)` }}
            >
                {/* ── Slide 1 – FTF Technology Innovation Awards ── */}
                <div className="w-full flex-shrink-0 relative flex items-start md:items-center min-h-[70vh] md:min-h-screen">
                    {/* Awards-specific background */}
                    <div className="absolute inset-0 hidden md:block z-0">
                        <div className="absolute inset-0" style={{
                            backgroundImage: `url(${bgAwards})`,
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            zIndex: -2
                        }} />
                        <div className="absolute inset-0" style={{
                            background: 'linear-gradient(to right, #000B16 0%, #000B16 35%, transparent 70%)',
                            zIndex: -1
                        }} />
                    </div>
                    <div className="absolute inset-0 md:hidden z-0" style={{
                        backgroundImage: `url(${bgAwards})`,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundColor: '#000B16'
                    }} />

                    <div className="site-shell relative z-10 pt-32 pb-16 md:pt-32 md:pb-20 w-full">
                        <div className="flex flex-col gap-[24px] md:gap-[30px] items-center md:items-start">
                            {/* Title */}
                            <h2 className="font-oswald font-bold text-white uppercase leading-[120%] text-center md:text-left text-[24px] sm:text-[28px] md:text-[33px] lg:text-[44px] xl:text-[55px] 2xl:text-[62px]">
                                FTF Technology Innovation Awards 2026
                            </h2>

                            {/* Gold separator */}
                            <SeparatorLine />

                            {/* Laurels + award text */}
                            <div className="flex items-center gap-3 md:gap-4 w-full justify-center md:justify-start">
                                <LaurelLeaf />
                                <p className="font-inter font-medium text-[#F8CA32] uppercase text-center tracking-[-0.01em] leading-[120%] text-[14px] sm:text-[17px] md:text-[23px] lg:text-[31px] xl:text-[38px] 2xl:text-[43px]">
                                    Best Middle to Back Office<br />Integration Solution
                                </p>
                                <LaurelLeaf mirrored />
                            </div>

                            {/* CTA button */}
                            <div className="w-full md:w-auto">
                                <a
                                    href="https://www.ftfnews.com/awards/ftf-news-technology-innovation-awards-2026/?section=categories_nomin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex md:inline-flex items-center justify-center bg-[#00C2FF] hover:scale-105 transition-transform duration-300 text-[#FDFDFD] font-inter font-bold rounded-[16px] shadow-lg text-[16px] py-[13px] px-[30px] md:text-[25.77px] md:py-[19px] md:px-[54px] leading-[31px]"
                                >
                                    Cast Your Vote
                                </a>
                            </div>
                        </div>

                        {/* ISO/SOC – mobile (centered) */}
                        <div className="mt-8 md:hidden flex justify-center">
                            <img src={isoSocLogo} alt="ISO Certified" className="h-16 w-auto" />
                        </div>

                        {/* ISO/SOC – desktop (bottom-right) */}
                        <div className="hidden md:flex absolute bottom-8 right-[85px]">
                            <img src={isoSocLogo} alt="ISO Certified" className="h-[60px] w-auto" />
                        </div>
                    </div>
                </div>

                {/* ── Slide 2 – Original FGC TMS banner ── */}
                <div className="w-full flex-shrink-0 relative flex items-start md:items-center min-h-[70vh] md:min-h-screen">
                    <BannerBackground />
                    <div className="site-shell relative z-10 pt-32 pb-6 md:pt-32 md:pb-20">
                        <div className="flex flex-col md:flex-row items-start md:items-center">
                            <div className="w-full md:w-3/4 lg:w-2/3 text-left">
                                <h1 className="font-oswald text-white text-3xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-4xl leading-[1.35] md:!leading-[1.35] mb-16 md:mb-4 font-normal">
                                    <strong className="font-bold">
                                        FGC TMS - A FIXED INCOME TRADING AND
                                        <span className="[@media(min-width:788px)_and_(max-width:1023px)]:hidden xl:hidden"> </span>
                                        <br className="hidden [@media(min-width:788px)_and_(max-width:1023px)]:block xl:block" />
                                        TRADE MANAGEMENT SYSTEM.
                                    </strong>
                                </h1>

                                <div className="relative">
                                    <ul className="font-inter text-gray-200 text-[16px] md:text-[16px] lg:text-[19px] xl:text-[22px] leading-relaxed mb-10 md:mb-24 list-disc pl-5 flex flex-col gap-2">
                                        <li>Cloud-native SaaS Based Fixed Income System</li>
                                        <li>Trading, Operations, Clearing, Risk & Compliance Engine</li>
                                        <li>Trusted by leading Broker Dealers</li>
                                        <li>Cut your systems cost by 50%+</li>
                                    </ul>

                                    <div className="absolute top-[180px] left-[22px]
                                        [@media(width:344px)]:top-[185px]
                                        [@media(width:344px)_and_(height:882px)]:top-[165px]
                                        [@media(min-width:442px)_and_(max-width:544px)]:top-[155px]
                                        [@media(min-width:544px)_and_(max-width:768px)]:top-[130px] md:top-[130px] md:left-[22px]
                                        [@media(min-width:926px)_and_(max-width:1024px)]:top-[130px] lg:top-[135px] lg:left-[24px]
                                        [@media(width:1024px)]:top-[145px]
                                        [@media(min-width:1024px)_and_(max-width:1174px)]:top-[145px]
                                        [@media(min-width:1174px)_and_(max-width:1280px)]:top-[145px]
                                        [@media(min-width:1280px)_and_(max-width:1329px)]:top-[165px]
                                        [@media(min-width:1328px)]:top-[165px]">
                                        <img
                                            src={heroScissors}
                                            alt="Cut Your Costs"
                                            className="w-auto h-auto max-w-[280px] md:max-w-[280px] lg:max-w-[400px] [@media(min-width:1024px)_and_(max-width:1279px)]:max-w-[350px]"
                                            fetchPriority="high"
                                        />
                                    </div>
                                </div>

                                <div className="relative flex flex-row items-center gap-2 mt-0 md:mt-8">
                                    <Link
                                        to="/schedule-demo"
                                        className="bg-[#00C2FF] hover:scale-105 transition-transform duration-300 text-[#FFFFFF] text-[14px] sm:text-[16px] md:text-lg font-bold py-3.5 sm:py-3 md:py-4 px-7 sm:px-8 md:px-12 rounded-[16px] shadow-lg whitespace-nowrap md:-mt-12 inline-block text-center"
                                    >
                                        Request a Demo To See How!
                                    </Link>
                                </div>

                                <div className="mt-24 md:hidden flex justify-start">
                                    <img src={isoSocLogo} alt="ISO Certified" className="h-16 w-auto opacity-100 translate-x-[5px] -translate-y-[36px]" />
                                </div>

                                <div className="mt-16 hidden md:block w-full md:w-1/4 lg:w-1/3">
                                    <div className="bottom-16 left-[10px]">
                                        <img src={isoSocLogo} alt="ISO Certified" className="h-[60px] w-auto" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Navigation dots */}
            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
                {Array.from({ length: SLIDE_COUNT }).map((_, i) => (
                    <button
                        key={i}
                        onClick={() => goToSlide(i)}
                        aria-label={`Go to slide ${i + 1}`}
                        className={`h-2 rounded-full transition-all duration-300 ${
                            i === current
                                ? 'w-6 bg-[#00C2FF]'
                                : 'w-2 bg-white/40 hover:bg-white/60'
                        }`}
                    />
                ))}
            </div>
        </section>
    );
};

export default Hero;
